export default 40;
